import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Snowflake } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e) {
      setErr(e.response?.data?.detail || "Falha ao entrar");
    } finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0A0A0B] px-4">
      <div className="w-full max-w-sm border border-[#27272A] bg-[#151618] p-8">
        <div className="mb-6 flex items-center gap-2">
          <div className="flex h-10 w-10 items-center justify-center bg-[#FF5500]"><Snowflake className="h-6 w-6 text-white" /></div>
          <div>
            <div className="font-heading font-black leading-none text-white">GLOBAL</div>
            <div className="text-[0.6rem] uppercase tracking-widest text-[#A1A1AA]">Painel Administrativo</div>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div><Label className="label-eyebrow">E-mail</Label><Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 rounded-none border-[#27272A] bg-[#0A0A0B]" /></div>
          <div><Label className="label-eyebrow">Senha</Label><Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 rounded-none border-[#27272A] bg-[#0A0A0B]" /></div>
          {err && <p data-testid="login-error" className="text-sm text-red-400">{err}</p>}
          <Button type="submit" data-testid="login-submit" disabled={loading} className="w-full rounded-none bg-[#FF5500] py-5 font-bold hover:bg-[#CC4400]">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Entrar
          </Button>
        </form>
      </div>
    </div>
  );
}
